import { render, staticRenderFns } from "./CategoryLookup.vue?vue&type=template&id=0bd9bdb2&scoped=true&"
import script from "./CategoryLookup.vue?vue&type=script&lang=js&"
export * from "./CategoryLookup.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLookup.vue?vue&type=style&index=0&id=0bd9bdb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9bdb2",
  null
  
)

export default component.exports